import Content from "../Content/Content";
import bulb from "../../assets/icons/BrazucaHow.svg";
import charts from "../../assets/icons/BrazucaAbout.svg";
import reddit from "../../assets/icons/reddit.svg";
import "./About.scss";

const About = () => {
  const eureka = (
    <>
      <p className="about__intro">
        Eureka is a Reddit post time analysis and scheduling service built to
        help content creators and businesses maximise reach and engagement.
        <br />
        <br />
        Reddit is one of the internet's most active communities, with millions
        of users spending a significant amount of time on the platform each day.
        By analysing user activity, Eureka identifies the optimal times for your
        content to be seen, upvoted, and discussed. These data-driven insights
        empower creators and businesses to schedule posts strategically,
        increasing their impact on one of the web's most popular platforms.
        <br />
        <br />
        <span className="about__brand">
          Boost brand awareness, grow your following, generate leads, and
          automate content publishing across
        </span>{" "}
        any Subreddit.
      </p>
    </>
  );

  const whyReddit = (
    <>
      <p className="about__intro">
        Content marketing on Reddit is valuable for creators and businesses
        because it allows them to connect with their target audience in a more
        authentic and organic way.
        <br />
        <br />
        Unlike traditional advertising, which is often perceived as intrusive or
        inauthentic, content marketing on Reddit focuses on sharing relevant
        insights, information, and entertainment that align with community
        interests. This approach helps build trust and credibility while
        encouraging genuine discussion and engagement with your brand's
        audience. This community-first approach drives customer growth and
        establishes a strong, lasting brand presence on the platform.
        <br />
        <br />
        As content marketing on Reddit is a cost-effective way to reach a large
        and engaged audience, it is a worthwhile investment for any creator or
        business looking to grow their online presence.
      </p>
    </>
  );

  const howItWorks = (
    <>
      <ol className="about__list">
        <li className="about__list-item">
          <p className="about__text">
            Select a specific time interval for the analysis
          </p>
        </li>
        <li className="about__list-item">
          <p className="about__text">Search for any Subreddit </p>
        </li>
        <li className="about__list-item">
          <p className="about__text">
            Receive statistics to find the best time to publish your content
          </p>
        </li>
        <li className="about__list-item">
          <p className="about__text">
            Let our AI assist you in writing your content
          </p>
        </li>
        <li className="about__list-item">
          <p className="about__text">Schedule posts in advance</p>
        </li>
      </ol>
    </>
  );

  return (
    <section className="about">
      <Content
        img={charts}
        left={true}
        scroll={180}
        id={"#first"}
        content={eureka}
        title={"About Eureka"}
      />

      <Content
        img={reddit}
        left={false}
        scroll={400}
        id={"#second"}
        content={whyReddit}
        title="Why Reddit"
      />
      <Content
        img={bulb}
        left={true}
        scroll={620}
        id={"#third"}
        content={howItWorks}
        title={"How it works"}
      />
    </section>
  );
};

export default About;
